import styles from "./DigitalServiceCard.module.css";
import { useLanguage } from "../../LanguageContext";

function DigitalServiceCard({ title, description, url, video }) {
    const { language } = useLanguage();

    const dynamicStyles = {
        fontFamily: language === "ARM" && "Mardoto",
        fontWeight: language === "ARM" && 500,
    };

    const handleOpen = () => {
        if (url) {
            window.open(url, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <div className={styles.serviceCard}>
            <div className={styles.serviceCardContent}>
                <div className={styles.serviceCardHeader}>Arca's services</div>
                <div className={styles.serviceCardText}>
                    <h2 className={styles.serviceCardTitle} style={dynamicStyles}>
                        {title}
                    </h2>
                    <p className={styles.serviceCardDescription} style={dynamicStyles}>
                        {description}
                    </p>
                </div>
                {url && url.length > 0 ? (
                    <button className={styles.serviceCardButton} onClick={handleOpen} style={dynamicStyles}>
                        Open
                    </button>
                ) : <div>&nbsp;</div>}
            </div>
            <div className={styles.serviceCardMedia}>
                <video
                    src={video}
                    className={styles.serviceCardVideo}
                    autoPlay
                    muted
                    loop
                    playsInline
                    disablePictureInPicture
                    controlsList="nodownload nofullscreen noremoteplayback"
                    style={{ pointerEvents: "auto" }}
                />
            </div>
        </div>
    );
}

export default DigitalServiceCard;
